import {logError} from '@yandex-delivery/modules/rum'

import {ResponseHeaders} from './types'

export class FetchError extends Error {
  name = 'FetchError'

  constructor(message: string, public response: {text?: string}) {
    super(message)
  }
}

export const getYaTraceId = (headers?: ResponseHeaders) => headers?.['x-yatraceid'] || 'missing'

export class ServerError<TBody = any> extends Error {
  name = 'ServerError'

  readonly url?: string
  readonly status: number
  readonly originError: FetchError
  readonly body: TBody
  readonly headers: ResponseHeaders

  constructor(options: {error: FetchError; status: number; body: any; headers: ResponseHeaders; url?: string}) {
    super(options.error.message)

    this.url = options.url
    this.status = options.status
    this.originError = options.error
    this.body = options.body
    this.headers = options.headers

    // Необходимо, чтобы ошибка приходила после события "fetch_error"
    setTimeout(() =>
      logError?.(
        {
          source: 'api',
          additional: {traceId: getYaTraceId(options.headers), status: options.status, url: options.url},
        },
        options.error,
      ),
    )
  }
}
